import { useCallback } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import getV1StockOdtOrderOrderlistfilter from '@services/api/stock/order/dt';

function useOrderDt() {
  const { cb, key } = getV1StockOdtOrderOrderlistfilter();

  const {
    data,
    isInitialLoading,
    refetch,
    isRefetching,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(key, cb, {
    getNextPageParam: (lastPage, allPages) => lastPage?.paging?.next && allPages.length + 1,
    select: (_data) =>
      _data.pages
        ?.flatMap((page) => page?.results || [])
        .map((orderDt) => ({ ...orderDt, isExpandable: true })),
    refetchInterval: 10_000,
  });

  const fetchNext = useCallback(() => {
    if (!isFetchingNextPage && hasNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, isFetchingNextPage, hasNextPage]);

  return {
    data: data || [],
    isInitialLoading,
    refetch,
    isRefetching,
    fetchNextPage: fetchNext,
    isFetchingNextPage,
  };
}

export default useOrderDt;
